<template>
  <iframe
    v-if="jotformId && initiatedThirdParty"
    :id="`JotFormIFrame-${jotformId}`"
    class="jotform-iframe"
    :title="jotformTitle"
    onload="window.parent.scrollTo(0,0)"
    allowtransparency="true"
    allow="geolocation; microphone; camera; fullscreen"
    :src="`https://form.jotform.com/${jotformId}`"
    frameborder="0"
    style="min-width:100%;max-width:100%;height:539px;border:none;"
    scrolling="no"
  />
</template>

<script lang="ts" setup>
const props = defineProps<{
  jotformId: string // 232753033620346
  jotformTitle?: string
}>()

const scriptId = 'jotform-script'
const { initiatedThirdParty } = useApp()

function initScript() {
  if (!initiatedThirdParty.value) {
    return
  }

  if (!document?.getElementById(scriptId)) {
    const script = document.createElement('script')
    script.async = true
    script.id = scriptId
    script.onload = () => {
      window.jotformEmbedHandler(`iframe[id="JotFormIFrame-${props.jotformId}"]`, 'https://form.jotform.com/')
    }

    script.src = `https://cdn.jotfor.ms/s/umd/latest/for-form-embed-handler.js`

    document.body.appendChild(script)
  }
}

function destroyJotform() {
  document?.getElementById(scriptId)?.remove()

  if (window.jotformEmbedHandler) {
    delete window.jotformEmbedHandler
  }

  // if (window._aidenApp) {
  //   delete window._aidenApp
  // }
}

watch(initiatedThirdParty, () => {
  initScript()
}, {
  immediate: true,
})

onUnmounted(() => {
  destroyJotform()
})
</script>

<style>
@import url("~layers/app/components/Thirdparty/Jotform.css");
</style>
